/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import { Patient } from '@/types/patient';
import { apiGet, apiPost } from '@/utils/api';

export const useCurrentPatientStore = defineStore('currentUserPatient', {
  state: () => ({
    user: null as Patient | null,
  }),
  actions: {
    // ログイン状態を確認する
    async isLoggedIn() {
      const { data } = await apiGet<Patient>('/api/patient/me');

      if (data) {
        this.user = data;
      }

      return !!data;
    },
    // メール認証のトークンをチェックする
    async verify(token: string) {
      return await apiPost<{
        patient_id: number;
        token: string;
        doctor_name: string;
        patient_name: string;
      }>('/api/patient/invite/token', { token });
    },
    // 患者の本登録をする
    async updateInitPassword(id: number, password: string) {
      return await apiPost('/api/patient/invite/login', {
        patient_id: id,
        password,
      });
    },
    //  ログインをする
    async login(email: string, password: string) {
      return await apiGet('/sanctum/csrf-cookie').then(async () => {
        const params = { email, password };
        const res = await apiPost<Patient>('/api/patient/login', params);

        if (res.success) {
          this.user = res.data;
        }

        return res;
      });
    },
    // パスワード再設定メール送信
    async sendPasswordResetLink(email: string) {
      const params = { email };
      return await apiPost('/api/patient/password/reset-request', params);
    },
    // パスワード再設定
    async resetPassword(
      userId: number,
      token: string,
      password: string,
      password_confirmation: string
    ) {
      const params = {
        id: userId,
        token,
        password,
        password_confirmation,
      };

      return await apiPost('/api/patient/password/reset', params);
    },
    // ログアウト
    async logout() {
      const res = await apiPost('/api/patient/logout');
      if (res.success) {
        this.user = null;
      }

      return res;
    },
    // メールアドレス認証
    async verifyEmail(userId: number, hash: string) {
      return await apiGet(`/api/email/verify/${String(userId)}/${hash}`);
    },
  },
});
